import React from "react";
import { Button } from "react-bootstrap";
import Modal from "react-bootstrap/Modal";
import { useForm } from "react-hook-form";
import { useMutation } from "react-query";
import { toast, ToastContainer } from "react-toastify";

import { useUserCancelReservedTokens } from "../../hooks/useUserCancelReservedToken";

function UserCancelReservedTokenModal(props) {
  const {
    formState: { errors },
    handleSubmit,
  } = useForm({
    defaultValues: {},
  });

  const { mutate, isLoading } = useMutation(useUserCancelReservedTokens, {
    onSuccess: (data) => {
      notifySuccess();
      props.refetch().then(() => {});
      props.onHide();
    },
    onError: (error) => {
      notifyError(error?.response.data.error);
    },
  });
  const notifyError = (error) => toast.error(error);
  const notifySuccess = () =>
    toast.success("Reservation request succesfull canceled");
  const onSubmit = (data) => {
    mutate(props.data.id);
  };

  function formatCreatedAt(createdAt) {
    const date = new Date(createdAt);
    const formattedDate = date.toLocaleDateString(); // Change toLocaleDateString to other format if needed
    return formattedDate;
  }

  return (
    <div>
      <Modal
        {...props}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <form onSubmit={handleSubmit(onSubmit)}>
          <Modal.Header closeButton>
            <Modal.Title>Confirm Cancellation</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {props?.data && (
              <>
                Are you sure you want to cancel the reservation of{" "}
                <strong>{props?.data.token_qty}</strong> shares created at{" "}
                <strong>{formatCreatedAt(props.data.created_at)}</strong> for
                amount of $<strong>{props.data.amount}</strong> ?
              </>
            )}
          </Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={props.onHide}>
              Close
            </Button>
            <Button
              type={"submit"}
              size="sm"
              variant="carre-purple w-25"
              disabled={isLoading}
            >
              {!isLoading ? "Cancel Reservation" : "Please wait"}
            </Button>
          </Modal.Footer>
        </form>
      </Modal>
    </div>
  );
}

export default UserCancelReservedTokenModal;
